import React, { useState, useEffect, useMemo } from 'react';
import { isNil, isPlainObject, isEqual } from 'lodash';
import { Form, FormItemProps } from 'antd';
import { Formatter } from '../utils';
import { transformRules, Rule } from '../utils/rules';
import InfoTooltip from '../components/InfoTooltip';
import MultiCheckbox from '../components/MultiCheckbox';
import { MultiCheckboxProps } from './MultiCheckbox/MultiCheckbox';

interface FormMultiCheckboxProps {
  name: FormItemProps['name'];
  label?: string;
  initialValues?: string[] | number[];
  tooltip?: PropPresets.Tooltip;
  disabled?: boolean;
  rules?: Rule[];
  options: PropPresets.Options;
  formItemProps?: FormItemProps;
  multiCheckboxProps?: Partial<MultiCheckboxProps>;
  showSelectAll?: boolean | PropPresets.StringOrElement;
  onChange?: (val: any[]) => void;
  colSpan?: number;
}

function FormMultiCheckbox(props: FormMultiCheckboxProps) {
  const {
    name,
    label,
    disabled,
    onChange,
    initialValues,
    formItemProps,
    multiCheckboxProps,
    showSelectAll,
    tooltip,
    colSpan = 6,
    options: propOptions,
    rules: propRules,
  } = props;

  const [options, setOptions] = useState<PropPresets.OptionObject[]>([]);

  const rules = useMemo(() => transformRules({ type: 'array' }, propRules), [propRules]);

  useEffect(() => {
    let formattedOps: PropPresets.OptionObject[] = [];
    if (!isNil(propOptions[0]) && !isPlainObject(propOptions[0])) {
      formattedOps = Formatter.makeOptions(propOptions as string[] | number[], true);
    }
    else {
      formattedOps = propOptions as PropPresets.OptionObject[];
    }

    if (!isEqual(options, formattedOps)) setOptions(formattedOps);
  }, [propOptions, options]);

  return (
    <Form.Item
      name={name}
      label={label}
      rules={rules}
      tooltip={InfoTooltip.Config(tooltip)}
      validateFirst
      {...formItemProps}
    >
      <MultiCheckbox
        options={options}
        disabled={disabled}
        initialValues={initialValues}
        showSelectAll={showSelectAll}
        colSpan={colSpan}
        onChange={onChange}
        {...multiCheckboxProps}
      />
    </Form.Item>
  );
}

export default FormMultiCheckbox;
